import createReducer from 'common/redux/utils/createReducer';
import {
  REQUEST_COMPANIES,
  RECEIVE_COMPANIES,
  OPEN_MODAL,
  CLOSE_MODAL,
} from '../actions/user';
import { Seq } from 'immutable';

const initialState = {
  companies: Seq(),
  modalOpened: false,
  isFetching: false,
  loaded: false,
};

export const usersReducer = createReducer(initialState, {
  [REQUEST_COMPANIES](state, action) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [RECEIVE_COMPANIES](state, { companies }) {
    return {
      ...state,
      isFetching: false,
      loaded: true,
      companies: Seq(companies),
    };
  },
  [OPEN_MODAL](state, action) {
    return {
      ...state,
      modalOpened: true,
    };
  },
  [CLOSE_MODAL](state, action) {
    return {
      ...state,
      modalOpened: false,
    };
  },
});

export const getCompanies = state => {
  return state.users.companies;
};

export const isModalOpened = state => {
  return state.users.modalOpened;
};



// WEBPACK FOOTER //
// ./src/modules/admin/reducers/user.js